import styled from '../../styled';
import {
  AppMockupChrome,
  ProductMockupBody,
  ProductMockupFrame
} from '../AppMockupChrome';

export {
  AppMockupChrome,
  ProductMockupBody,
  ProductMockupFrame
};

/** Small colored initial circle standing in for a merchant logo. */
export const MerchantDot = styled('span')<{ bg: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${(p) => p.bg};
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  flex-shrink: 0;
`;
